import { render } from "./tinyEditor.vue?vue&type=template&id=2a14d8b0&scoped=true&ts=true"
import script from "./tinyEditor.vue?vue&type=script&lang=ts"
export * from "./tinyEditor.vue?vue&type=script&lang=ts"

import "./tinyEditor.vue?vue&type=style&index=0&id=2a14d8b0&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a14d8b0"]])

export default __exports__